// Adaptateur statique : catalogue servi depuis /data/products.json,
// formulaires relayés vers les scripts PHP de l'hébergement (/api/*.php).
// Conserve la signature axios ({ data }, erreurs avec e.response.data.detail).

export const API = "/api";

let productsPromise = null;
function loadProducts() {
  if (!productsPromise) {
    productsPromise = fetch("/data/products.json").then((r) => {
      if (!r.ok) throw mkError(r.status, "Catalogue indisponible");
      return r.json();
    });
  }
  return productsPromise;
}

function mkError(status, detail) {
  const e = new Error(detail);
  e.response = { status, data: { detail } };
  return e;
}

async function get(url) {
  const [path, query] = url.split("?");
  const params = new URLSearchParams(query || "");

  if (path === "/products") {
    let items = await loadProducts();
    const brand = params.get("brand");
    if (brand) items = items.filter((p) => p.brand === brand);
    return { data: [...items].sort((a, b) => a.order - b.order) };
  }

  const productMatch = path.match(/^\/products\/(.+)$/);
  if (productMatch) {
    const items = await loadProducts();
    const p = items.find((x) => x.reference === productMatch[1]);
    if (!p) throw mkError(404, "Référence introuvable");
    return { data: p };
  }

  if (path === "/newsletter/confirm") {
    return phpCall("newsletter-confirm.php?token=" + encodeURIComponent(params.get("token") || ""), null, "GET");
  }

  throw mkError(404, "Ressource inconnue");
}

async function post(url, body) {
  const name = url.replace(/^\//, "").replace(/\//g, "-");
  return phpCall(name + ".php", body, "POST");
}

async function phpCall(endpoint, body, method) {
  let r;
  try {
    r = await fetch(`${API}/${endpoint}`, {
      method,
      headers: body ? { "Content-Type": "application/json" } : undefined,
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch {
    throw mkError(0, "Connexion impossible. Réessaie dans un instant.");
  }
  let data = {};
  try { data = await r.json(); } catch { /* réponse vide */ }
  if (!r.ok) throw mkError(r.status, data.detail || "Une erreur est survenue.");
  return { data };
}

export const api = { get, post };

export function apiError(e, fallback = "Une erreur est survenue.") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ") || fallback;
  return fallback;
}
